<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="loadApprovalLogs"
      item-key="id"
      :items-per-page="15"
      :sort-by="['createdAt']"
      :sort-desc="[true]"
      no-data-text="No Records Found!"
      no-results-text="No Records Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
    </v-data-table>
    <load-approval-pin-form />
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import loadApprovalPinHeaders from '@/models/load-approval-logs-headers';
import LoadApprovalPinForm from '@/components/load_approval/LoadApprovalPinForm';

export default {
  name: 'LoadApprovalLogs',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('loadApproval', ['loadApprovalLogs', 'pending']),
    headers: () => loadApprovalPinHeaders
  },
  components: { LoadApprovalPinForm }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
